import type { StatusColorName } from "@kontextwerk/web-sdk/core/display/status"
import {
  buildRichTooltip,
  tooltipField,
  tooltipTitle,
} from "../../../../../../../../../../../_shared/_logic/rich-tooltips"

export type SourceCleanupInstructionPresentation = {
  label: string
  subLabel: string
  copyValue: string
  color: StatusColorName
}

export type SourceCleanupTooltipField = {
  label: string
  value: string
}

const instructionColor = (label: string, subLabel: string): StatusColorName => {
  const normalizedLabel = label.trim().toLowerCase()
  const normalizedAction = subLabel.trim().toLowerCase()

  if (
    normalizedAction.includes("löschen") ||
    normalizedAction.includes("entfernen") ||
    normalizedAction.includes("nicht übernehmen")
  ) {
    return "rose"
  }

  if (
    normalizedLabel.includes("@") ||
    normalizedAction.includes("e-mail") ||
    normalizedAction.includes("email")
  ) {
    return "cyan"
  }

  if (
    normalizedAction.includes("telefon") ||
    normalizedAction.includes("mobil") ||
    normalizedAction.includes("festnetz") ||
    /^\+?[0-9][0-9\s/().-]{4,}$/.test(label.trim())
  ) {
    return "violet"
  }

  if (normalizedAction.includes("rolle")) return "orange"

  return "cyan"
}

export const sourceCleanupInstruction = (
  label: string,
  subLabel: string,
  copyValue: string,
): SourceCleanupInstructionPresentation => ({
  label: label.trim(),
  subLabel: subLabel.trim(),
  copyValue: copyValue.trim(),
  color: instructionColor(label, subLabel),
})

export const sourceCleanupInstructionTooltip = (
  instruction: SourceCleanupInstructionPresentation,
  context: SourceCleanupTooltipField[] = [],
): string =>
  buildRichTooltip([
    tooltipTitle("Im Kehrbezirksprogramm erledigen"),
    tooltipField("Wert", instruction.label),
    tooltipField("Aktion", instruction.subLabel),
    ...context.map((field) => tooltipField(field.label, field.value)),
  ])
